const state = {
  userInfo: {},
  lang: 'it',
  loading: false,
  errorKey: null,
  errorSubKey: null,
  errorSubKeyParams: [],
  errorImage: null,
  redirect: null,
  actionRedirect: null,
  modal: false,
  modalText: ''
}

export default state
